// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"Equipment_paginationPageDropdownWrap__NzDIs"};